import { create } from 'zustand';
import API from '../lib/api';

const useSettingsStore = create((set, get) => ({
  settings: null,
  content: null,
  loading: true,
  error: null,

  fetchSettings: async () => {
    try {
      const [settingsRes, contentRes] = await Promise.all([
        API.get('/settings'),
        API.get('/content')
      ]);
      const settings = settingsRes.data && typeof settingsRes.data === 'object' ? settingsRes.data : {};
      const content = contentRes.data && typeof contentRes.data === 'object' ? contentRes.data : {};

      // Apply design system CSS variables
      if (settings.design_system) {
        const ds = settings.design_system;
        const root = document.documentElement;
        if (ds.primary_color) root.style.setProperty('--ap-primary', ds.primary_color);
        if (ds.accent_color) root.style.setProperty('--ap-accent', ds.accent_color);
        if (ds.bg_color) root.style.setProperty('--ap-bg', ds.bg_color);
        if (ds.surface_color) root.style.setProperty('--ap-surface', ds.surface_color);
        if (ds.text_color) root.style.setProperty('--ap-text', ds.text_color);
        if (ds.text_muted) root.style.setProperty('--ap-text-muted', ds.text_muted);
        if (ds.border_color) root.style.setProperty('--ap-border', ds.border_color);
        if (ds.overlay_opacity) root.style.setProperty('--ap-overlay', ds.overlay_opacity);
      }

      // Set document title
      if (settings.site_title) {
        document.title = settings.site_title;
      }

      set({ settings, content, loading: false, error: null });
    } catch (err) {
      console.error('Settings fetch error:', err);
      set({ loading: false, error: err.message });
    }
  },

  updateSettings: (newSettings) => {
    set({ settings: { ...get().settings, ...newSettings } });
    // Re-apply CSS variables
    const ds = newSettings.design_system || get().settings?.design_system;
    if (ds) {
      const root = document.documentElement;
      Object.entries({
        primary_color: '--ap-primary', accent_color: '--ap-accent',
        bg_color: '--ap-bg', surface_color: '--ap-surface',
        text_color: '--ap-text', text_muted: '--ap-text-muted',
        border_color: '--ap-border', overlay_opacity: '--ap-overlay'
      }).forEach(([key, cssVar]) => {
        if (ds[key]) root.style.setProperty(cssVar, ds[key]);
      });
    }
  },

  updateContent: (newContent) => {
    set({ content: { ...get().content, ...newContent } });
  },

  // Helper to get text with fallback
  t: (section, key, fallback = '') => {
    const content = get().content;
    return content?.[section]?.[key] || fallback;
  }
}));

export default useSettingsStore;
